<template>
<!--  <div class="login">-->
<!--    <div id="box">-->
<!--      <img src="/static/img/login-logo.png" style="margin: 0 auto;display: block;margin-bottom: 10px;"/>-->
<!--      <h1>智达云服务平台</h1>-->

<!--      <el-form :model="LoginUser" status-icon :rules="rules" ref="LoginUser" label-width="100px" class="demo-ruleForm">-->
<!--        <el-form-item prop="user">-->
<!--          <span style="background: url(/static/img/user.png) left center no-repeat;"></span>-->
<!--          <el-input type="text" v-model="LoginUser.user" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="pwd">-->
<!--          <span style="background: url(/static/img/pwd.png) left center no-repeat;"></span>-->
<!--          <el-input type="password" v-model="LoginUser.pwd" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="code" class="codebox">-->
<!--          <el-input type="text" id="inputCode" v-model="LoginUser.code" autocomplete="off"></el-input>-->
<!--          <div id="checkCode" class="code" @click="createCode(4)">{{code}}</div>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button type="primary" id='sbt' @click="submitForm('LoginUser')">登录</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--    </div>-->
<!--  </div>-->
  <div class="bg">
    <div class="title">
      <img src="/static/img/login_logo.png" class="logo">
    </div>
    <div class="wd1300">
      <div class="hos-cent-right">
        <div class="center-login">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <p class="user_login">用户登录</p>
          <div class="log-tab">
            <el-form :model="LoginUser" status-icon :rules="rules" ref="LoginUser" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="user">
                <div class="min-log-lab">
                <span style="background: url(/static/img/l.png) #2a307b no-repeat 10px center;"></span>
                <input type="text" v-model="LoginUser.user" autocomplete="off" class="user" placeholder="请输入用户名"></input>
                </div>
              </el-form-item>
              <el-form-item prop="pwd">
                <div class="min-log-lab">
                <span style="background: url(/static/img/pas.png) #2a307b no-repeat 10px center;"></span>
                <input type="password" v-model="LoginUser.pwd" autocomplete="off" class="pwd"  placeholder="请输入密码"></input>
                </div>
              </el-form-item>
              <el-form-item prop="code" class="codebox">
                <div class="min-log-lab1">
                <input type="text" id="inputCode" v-model="LoginUser.code" autocomplete="off"  placeholder="请输入验证码"></input>
                  <div>
                    <span id="checkCode" class="code" @click="createCode(4)">{{code}}</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" id='sbt' @click="submitForm('LoginUser')" style="position: relative;top: -65px;">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <p class="zd-footer">河北智达光电股份有限公司</p>
    </div>
  </div>
</template>

<script>
  import jwt_decode from 'jwt-decode'
  export default {
    data() {
      var user = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          callback();
        }
      };
      var pwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      var code = (rule, value, callback) => {
        var checkCode = document.getElementById("checkCode").innerHTML;
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else if (value.toUpperCase() !== checkCode.toUpperCase()) {
          callback(new Error('验证码输入有误'));
          this.createCode(4);
        } else {
          callback();
        }
      };
      return {
        user: "",
        pwd: "",
        code: "",
        LoginUser: {
          user: '',
          pwd: '',
          code: '',
        },
        rules: {
          user: [
            {validator: user, trigger: 'blur'}
          ],
          pwd: [
            {validator: pwd, trigger: 'blur'}
          ],
          code: [
            {validator: code, trigger: 'blur'}
          ],
        }
      }
    },
    methods: {
      createCode: function (length) {
        var $code = "";
        var codeLength = parseInt(length); //验证码的长度
        var checkCode = document.getElementById("checkCode");
        ////所有候选组成验证码的字符，当然也可以用中文的
        var codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
          'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
          'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');
        //循环组成验证码的字符串
        console.log(codeLength);
        for (var i = 0; i < codeLength; i++) {
          //获取随机验证码下标
          var charNum = Math.floor(Math.random() * 62);
          //组合成指定字符验证码
          $code += codeChars[charNum];
        }
        this.code = $code;
        if (checkCode) {
          //为验证码区域添加样式名
          checkCode.className = "code";
          //将生成验证码赋值到显示区
          this.code = $code;
        }
      },
      validateCode: function () {
        //获取显示区生成的验证码
        var checkCode = document.getElementById("checkCode").innerHTML;
        //获取输入的验证码
        var inputCode = document.getElementById("inputCode").value;
        //console.log(checkCode);
        //console.log(inputCode);
        if (inputCode.length <= 0) {
          alert("请输入验证码！");
          return false;
        } else if (inputCode.toUpperCase() != checkCode.toUpperCase()) {
          alert("验证码输入有误！");
          this.createCode(4);
          return false;
        } else {
          // let formData = new FormData();
          // formData.append('username', this.user);
          // formData.append('password', this.pwd);
          // fetch("/zd_cloud/api/login", {
          //   method: 'post',
          //   body: formData,
          //   // body:JSON.stringify({username:"13211111111",password:"123456"})
          //
          // })
          //   .then(result => {
          //     return result.json();//解析流
          //   })
          //   .then(data => {
          //     console.log(data)
          //     //this.$router.push("/monitoring");
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        }
      },


      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post("/api/v1/user/login", {
              mobile: this.LoginUser.user,
              password: this.LoginUser.pwd
            }).then(res => {
              if (res.data.code === "200") {
                let token = res.data.token;
                //存储token
                localStorage.setItem('eleToken', token);
                localStorage.setItem('user', this.LoginUser.user);
                localStorage.setItem('pwd', this.LoginUser.pwd);
                //解析token
                const decoded = jwt_decode(token);
                //token存储到vuex
                this.$store.dispatch("setAuthenticated",!this.isEmpty(decoded));
                this.$store.dispatch("setUser",decoded);
                if ( this.LoginUser.user == "aplhjk"){
                  this.$router.push('/monitoring');
                }else {
                  this.$router.push('/Home');
                }
                console.log(this.$store)
              } else if (res.data.code === "10001") {
                alert(res.data.msg)
              }
              // // 登录成功
              // const {token} = res.data;
              // localStorage.setItem("eleToken", token);
              //
              // // 解析token
              // const decode = jwt_decode(token);
              //
              // // 存储数据
              // this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
              // this.$store.dispatch("setUser", decode);
              //
              // //页面跳转
              // this.$router.push("/index");
            });

          } else {
            return false;
          }
        });
      },
      isEmpty(value){
        return(
          value === undefined ||
          value === null ||
          (typeof value === 'object' && Object.keys(value).length === 0) ||
          (typeof value === 'string' && value.trim().length === 0)
        )
      },
    },
    created() {
      this.createCode(4);
    }
  }
  $(function () {
    $(document).keyup(function (event) {
      if (event.keyCode == 13) {
        $("#login").trigger("click");
      }
    });
  })
</script>

<style>
  .wd1300{ width: 1300px; margin: 0 auto;}
  .title{padding-left: 3%;padding-top: 2%;}
  .logo{width: 26%;}
  .bg{background: url(/static/img/bg.png) #070c41 center center no-repeat fixed;width:100%;height: 100%;}
  .hos-cent-right{ width: 50%; height: 100%; float: right;margin-right:0px;}
  .center-login{ width: 66%; height:430px;margin-top: 15%; background:rgba(255,255,255,.1); border-radius:6px ; float: right; margin-right: 20px; position: relative;border: 1px solid #132f65;}
  .border_top_left,.border_top_right,.border_bottom_left,.border_bottom_right{width: 34px;height: 34px;position: absolute;background:url(/static/img/border_angle.png) no-repeat center center;}
  .border_top_right{top: 0px;right: 0px;transform: rotate(90deg);}
  .border_bottom_left{bottom: 0px;left: 0px;transform: rotate(-90deg);}
  .border_bottom_right{bottom: 0px;right: 0px;transform: rotate(180deg);}
  .log-tab{ padding: 8% 0 0; width: 80%; margin: 0 auto;}
  .user_login{color: #fff;color: #fff;font-size: 26px;margin:0;width: 100%;text-align: center;margin-top: 30px;}
  .zd-footer{color: #a5a6b1;position: absolute;bottom: 0;left: 45%;font-size: 14px;}
  .min-log-lab{ width: 88%; height: 45px; display: block; border-radius:5px; margin-bottom: 1%; font-size: 16px;}
  .min-log-lab input{ border: none; float: left; padding-left: 40px; height: 45px; line-height: 34px;width:100%;border: 1px solid #2c338f;border-radius:2px;font-size: 16px;color: #fff;padding-top: 0px;}
  .min-log-lab input:focus {outline:none;border: 1px solid #00b8ff;}
  .min-log-lab .user{background: url(/static/img/l.png) #2a307b no-repeat 10px center;}
  .min-log-lab .pwd{background: url(/static/img/pas.png) #2a307b no-repeat 10px center;}
  .min-log-lab1{ border: none;width: 50%;height: 45px;}
  .min-log-lab1 input{ display: block; float: left; width: 50%;  border: 1px solid #0b3968; border-radius: 4px; margin-right: 16px;width: 50%;height: 45px;font-size: 16px;padding-left: 10px;background: #2a307b;color: #fff;}
  .min-log-lab1 input:focus {outline:none;border: 1px solid #6897b8;}
  .min-log-lab1 div{float: right; width: 74%; display: block; height: 45px;  border: 1px solid #ccc !important; border-radius: 4px; background: #fff;position: relative;left: 170px;
    top: -48px;}
  #checkCode{width: 74%; margin: 0 auto; display: block;}
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ffffff;
  }
  input:-moz-placeholder, textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ffffff;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ffffff;
  }
  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ffffff;
  }



  .el-form-item__content {
    margin-left: 0 !important;
    position: relative;
  }

  .el-form-item__content > span {
    position: absolute;
    top: 7px;
    left: 10px;
    color: #E36b85;
    width: 26px;
    height: 26px;
    display: block;
    z-index: 99;
  }

  .el-input__inner {
    padding-left: 46px !important;
  }

  .login {
    width: 100%;
    height: 100%;
    background: url(/static/img/login-bg.png) no-repeat center center;
    background-size: 100% 100%;
  }

  #inputCode {
    width: 100%;
    float: left;
    margin-right: 20px;
  }

  #box {
    width: 360px;
    padding: 40px;
    box-sizing: border-box;
    position: absolute;
    right: 260px;
    top: 50%;
    margin-top: -205px;
    background: #333a64;
    border: 1px solid #39416f;
    border-radius: 10px;
  }

  .codebox {
    width: 100%;
  }

  .codebox .el-input {
    float: left;
    width: 53%;
    margin-right: 20px;
  }

  #box > h1 {
    height: 40px;
    line-height: 40px;
    width: auto;
    color: #FFFFFF;
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
    background-size: 40px 40px;
    font-weight: normal;
  }

  #box > p {
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #box > p > span {
    position: absolute;
    top: 7px;
    left: 28px;
    color: #E36b85;
    width: 26px;
    height: 26px;
    display: inline-block;
  }

  #box > p > input {
    width: 280px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #c1c2c6;
    border-radius: 6px;
    outline: none;
    padding-left: 40px;

  }

  #box > p > input:focus {
    border: none;
  }

  #mpanel2 {
    height: 42px;
    line-height: 40px;
    padding: 0 20px;
    width: auto;
    margin-bottom: 40px;

  }

  #mpanel2 > input {
    width: 160px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #c1c2c6;
    border-radius: 6px;
    outline: none;
    padding-left: 40px;
    float: left;
    margin-right: 10px;
  }

  .cerify-code-panel, .verify-code {
    float: left;
    height: 42px !important;
  }

  #login_container {
    width: 322px;
    margin: 20px auto 10px auto;
    display: flex;
    position: relative;
    align-items: center;
    color: #FFFFFF;
    height: 20px;
    line-height: 20px;
  }

  #sbt {
    width: 100%;
    height: 45px;
    height: 45px;
    font-size: 16px;
    margin-top: 10%;
    border: none;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
  }

  #login_container label {
    text-align: left;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
    box-sizing: border-box;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    -webkit-appearance: none;
    border-radius: 2px;
    background: url(/static/img/nocheckbox.png) no-repeat center;
    outline: none;
  }

  .checkBox input[type=checkbox]:checked {
    background: url(/static/img/checkbox.png) no-repeat center center;
  }

  #login_container a {
    margin-left: 130px;
    color: #FFFFFF;
  }

  .code {
    font-style: italic;
    color: blue;
    font-size: 30px;
    border: 0;
    padding: 2px 3px;
    letter-spacing: 3px;
    font-weight: bolder;
    float: left;
    cursor: pointer;
    width: 102px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue